"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupContext = void 0;
var React = require("react");
exports.PopupContext = React.createContext({
    popupManager: undefined,
});
//# sourceMappingURL=PopupContext.js.map